import { regions } from '~/utils/region';

const ORIGINLESS_BASE = 'https://placeholder.invalid';
const ORIGINLESS_HOST = 'placeholder.invalid';

export default function destinationPath(href: string): string {
  if (!isResolvableWithoutAPage(href)) return href;

  let url;

  try {
    url = new URL(href, ORIGINLESS_BASE);
  } catch {
    return href;
  }

  if (!servesOurPages(url.hostname)) return href;

  return `${url.pathname}${url.search}`;
}

// Only an absolute path or a full absolute url means the same thing wherever it was clicked from.
// Anything else — `news/x`, `www.site/x`, `https:news/x` — React Router resolves against the route
// that rendered it, which this function cannot see, so any path it built would name a page the
// browser never opens.
function isResolvableWithoutAPage(href: string): boolean {
  return href.startsWith('/') || /^[a-z][a-z0-9+.-]*:\/\//i.test(href);
}

function servesOurPages(hostname: string): boolean {
  if (hostname === ORIGINLESS_HOST) return true;

  if (typeof window !== 'undefined' && hostname === window.location.hostname)
    return true;

  return regions.some(
    ({ domain }) => hostname === domain || hostname === `www.${domain}`
  );
}
